import React from 'react';
import { Search, X } from 'lucide-react';
import { FilterSelect } from './FilterSelect';

export const ProductFiltersBar = ({
  searchQuery,
  setSearchQuery,
  filterProductType,
  setFilterProductType,
  filterManufacturer,
  setFilterManufacturer,
  filterFamily,
  setFilterFamily,
  uniqueProductTypes,
  uniqueManufacturers,
  uniqueFamilies,
}) => {
  const hasActiveFilters = filterProductType || filterManufacturer || filterFamily;

  const clearFilters = () => {
    setFilterProductType('');
    setFilterManufacturer('');
    setFilterFamily('');
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 px-3 py-2 bg-gray-700 rounded-lg border border-gray-600 w-full">
        <Search className="w-4 h-4 text-gray-400 shrink-0" />
        <input
          type="text"
          placeholder="Search products..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="bg-transparent border-0 outline-0 text-white placeholder-gray-400 text-sm w-full"
        />
      </div>

      <div className="flex items-center gap-2 flex-wrap">
        <div className="flex-1 min-w-[150px]">
          <FilterSelect
            value={filterProductType}
            onChange={setFilterProductType}
            options={uniqueProductTypes}
            placeholder="Product Type"
          />
        </div>
        <div className="flex-1 min-w-[150px]">
          <FilterSelect
            value={filterManufacturer}
            onChange={setFilterManufacturer}
            options={uniqueManufacturers}
            placeholder="Manufacturer"
          />
        </div>
        <div className="flex-1 min-w-[150px]">
          <FilterSelect
            value={filterFamily}
            onChange={setFilterFamily}
            options={uniqueFamilies}
            placeholder="Family"
          />
        </div>
        {hasActiveFilters && (
          <button
            type="button"
            onClick={clearFilters}
            className="inline-flex items-center justify-center gap-1 px-3 py-2 rounded-lg border border-red-600 bg-red-600/20 text-red-300 text-sm font-medium hover:bg-red-600/30 transition-colors cursor-pointer shrink-0"
            title="Clear all filters"
          >
            <X className="w-4 h-4" />
            Clear Filters
          </button>
        )}
      </div>
    </div>
  );
};
